import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a571e08a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "loadingModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-dialog modal-dialog-centered" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "modal-content spinner-loading" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "spinner-border text-center text-primary" })
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3, 512))
}